import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export default function PrivateRoute({ children }) {
  const { approved, loading } = useAuth();

  if (loading) return <p>Loading...</p>;
  if (!approved) return <Navigate to="/" />;
  return children;
}
